import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import { Route, Routes } from "react-router";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./routes";
import { ProgramPage } from "./components/ProgramPage";
import HomePage from "./components/HomePage";
import { useEmbedAutoResize } from "./hooks/useEmbedAutoResize";

function App() {
  // When embedded in an iframe, keep the parent iframe sized to our content.
  useEmbedAutoResize();

  return (
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path={AppRoutes.Home} element={<HomePage />} />
          <Route path={AppRoutes.ProgramId} element={<ProgramPage />} />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
